import { render, staticRenderFns } from "./MyLinks.vue?vue&type=template&id=c9b9f5fa&scoped=true&"
import script from "./MyLinks.vue?vue&type=script&lang=ts&"
export * from "./MyLinks.vue?vue&type=script&lang=ts&"
import style0 from "./MyLinks.vue?vue&type=style&index=0&id=c9b9f5fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b9f5fa",
  null
  
)

export default component.exports